export function getView(completed) {
  return completed ? 'Complete' : 'SetupPayment'
}
